export default __webpack_public_path__ + "static/media/guide_me@3x.358b88f9.webp";